import { createAPI } from '@common'

export default {
  // 操作：还原
  postMamGarbageRestore: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0hbscbhf0sftupsf', 'POST', config),
  // 操作：彻底删除
  deleteMamGarbageDelete: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0hbscbhf0efmfuf', 'DELETE', config)
}
